import { Inject, Injectable } from '@angular/core';

import { Session } from './session';

const SUPPORT_TYPE = {
  general: 0,
  customerSuccess: 1,
  accountManager: 2,
  accountExecutive: 3,
};

const GENERAL_SUPPORT_THRESHOLD = 10;
const MID_MARKET_THRESHOLD = 40;

@Injectable()
export class SupportContact {
  public isAccountManager: boolean;
  public isAccountExecutive: boolean;
  public isGeneralSupport: boolean;
  public accountRepresentative: any;
  public isCustomerSuccess: boolean;

  constructor(private session: Session) {
    this.initContactInfo();
  }

  private setAccountRepresentative(representative: any): void {
    this.accountRepresentative = {
      id: representative.id,
      name: representative.name,
      email: representative.email,
      phone: representative.phone,
      photoUrl: representative.photo_url,
    };
  }

  private getSupportType(): number {
    const session = this.session;
    const showGeneralSupport: boolean = !session.companyHasElds(); // is free account
    if (showGeneralSupport) return SUPPORT_TYPE.general;

    const accountStatus: string = session.getCompanyProperty('sf_account_status');
    const fleetSize: number = session.getCompanyProperty('composite_fleet_size') || 0;
    const isSmallFleet = fleetSize < GENERAL_SUPPORT_THRESHOLD;
    const isSmb = fleetSize <= MID_MARKET_THRESHOLD;

    if (accountStatus === 'Trial') {
      if (isSmallFleet) return SUPPORT_TYPE.general;
      else if (isSmb) return SUPPORT_TYPE.customerSuccess;
      else return SUPPORT_TYPE.accountManager;
    } else if (accountStatus === 'Customer') {
      if (isSmb) return SUPPORT_TYPE.customerSuccess;
      else return SUPPORT_TYPE.accountManager;
    }
    return SUPPORT_TYPE.general;
  }

  private initContactInfo(): void {
    const type = this.getSupportType();
    const session = this.session;

    if (type === SUPPORT_TYPE.accountExecutive) {
      this.setAccountRepresentative(session.getAccountExecutive());
      this.isAccountExecutive = true;
    } else if (type === SUPPORT_TYPE.accountManager) {
      this.setAccountRepresentative(session.getAccountManager());
      this.isAccountManager = true;
    } else if (type === SUPPORT_TYPE.customerSuccess) {
      this.isCustomerSuccess = true;
    } else {
      this.isGeneralSupport = true;
    }
  }
}
